import type { ReactNode } from "react";

// Picks one phrase out of an otherwise-sans headline by swapping it to an italic serif --
// EB Garamond, the open-source stand-in for the Apple Garamond treatment on socialcorn.com's
// hero. Font-size/color/letter-spacing all inherit from the surrounding heading (this only ever
// swaps family + style), the same way the reference keeps the accent phrase at the same scale as
// the rest of the line.
export default function SerifAccent({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span className={`font-accent-serif italic ${className ?? ""}`}>
      {children}
    </span>
  );
}
